import { render } from "./AppSigningStart.vue?vue&type=template&id=478a8ef8&scoped=true"
import script from "./AppSigningStart.vue?vue&type=script&lang=js"
export * from "./AppSigningStart.vue?vue&type=script&lang=js"

import "./AppSigningStart.vue?vue&type=style&index=0&id=478a8ef8&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-478a8ef8"]])

export default __exports__